import { Controller } from '@hotwired/stimulus'

/**
 * Нажимает единственную кнопку внутри себя сразу после отрисовки.
 *
 * Своей логики у контроллера нет — и в этом смысл: каждый сценарий уже
 * описан существующей кнопкой со всеми её правилами (вход для гостя, CSRF и
 * премодерация для формы), и второй путь к тому же действию означал бы вторую
 * реализацию тех же правил.
 *
 * Где используется:
 * - страница тренера с `?review=1` — ссылка, которую тренер шлёт ученику:
 *   открывается форма отзыва (гостю — окно входа);
 * - кнопка claim после того, как гость нажал её и вошёл: нажимать второй раз
 *   ему уже не нужно.
 *
 * Пример:
 * <div class="contents" data-controller="autoclick">
 *   <%= render 'reviews/leave_button', ... %>
 * </div>
 */
export default class AutoclickController extends Controller {
  connect() {
    // Turbo восстанавливает страницу из кэша при возврате «назад» и заново
    // зовёт connect. Без отметки действие повторилось бы поверх страницы,
    // которую человек уже закрыл.
    if (this.element.dataset.autoclicked === 'true') return
    this.element.dataset.autoclicked = 'true'

    // Клик в следующем кадре: обработчики кнопки (login-modal у гостя, Turbo
    // у вошедшего) вешаются на connect своих контроллеров, а порядок connect'ов
    // Stimulus не гарантирует — клик в этом же кадре мог уйти в пустоту.
    requestAnimationFrame(() => this.element.querySelector('button')?.click())
  }
}
